export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/8efd5543275798f3b16e60132764029d.jpg)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-8 flex justify-center">
          <img 
            src="https://public.readdy.ai/ai/img_res/ef6fc1e4-8111-4f5d-845e-fd6348221166.png" 
            alt="Лучшие казино онлайн с бонусами" 
            className="w-32 h-32 object-contain drop-shadow-2xl"
          />
        </div>
        
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 drop-shadow-lg leading-tight">
          Лучшие казино онлайн с бонусами 2026:<br />где дают больше всех?
        </h1>
        
        <p className="text-lg sm:text-xl text-white/95 mb-8 max-w-4xl mx-auto leading-relaxed drop-shadow-md">
          Глубокий анализ не просто размера бонуса, а его реальной ценности с учетом вейджера, ограничений и игр, на которые он распространяется. Мы рассчитали индекс выгодности для каждого предложения, чтобы вы могли выбрать действительно прибыльный бонус.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="#top-casinos" 
            className="px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-lg font-semibold rounded-full hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-2xl hover:shadow-orange-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Смотреть рейтинг
          </a>
          <a 
            href="#calculator" 
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-full hover:bg-white/20 transition-all duration-300 border-2 border-white/30 whitespace-nowrap cursor-pointer"
          >
            Калькулятор вейджера
          </a>
        </div>
        
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-3xl font-bold text-orange-400 mb-2">15+</div>
            <div className="text-white/90 text-sm">Проверенных казино онлайн</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-3xl font-bold text-orange-400 mb-2">500%</div>
            <div className="text-white/90 text-sm">Максимальный бонус</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-3xl font-bold text-orange-400 mb-2">x30</div>
            <div className="text-white/90 text-sm">Минимальный вейджер</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-3xl font-bold text-orange-400 mb-2">2ч</div>
            <div className="text-white/90 text-sm">Быстрый вывод</div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/70"></i>
      </div>
    </section>
  );
}